import Hotjar from '@hotjar/browser';
import Ambiente, { TIPO_AMBIENTE } from './Ambiente';
import Configuracao from './Configuracao';

/**
 * @classdesc Agrupa métodos para auxiliar na manipulação do Hotjar.
 */
class HotjarUtil {
    static #instance = null;

    constructor() {
        if (HotjarUtil.#instance) {
            throw new Error('Deve existir apenas uma instância.');
        }

        HotjarUtil.#instance = this;
    }

    static inicializar() {
        return HotjarUtil.#initHotjar();
    }

    static #initHotjar() {
        if (!Configuracao.HABILITAR_HOTJAR) {
            console.info('Hotjar desabilitado.');
            return false;
        }

        if (Ambiente.isHotjarInicializado()) {
            console.info('Hotjar já inicializado.');
            return true;
        }

        const userAgent = navigator.userAgent || window.opera;

        if (userAgent && userAgent.toLowerCase().indexOf('headless') !== -1) {
            console.info('Hotjar não será inicializado para userAgent Headless.');
            return false;
        }

        let siteId;

        if (
            Ambiente.getDescricao() === TIPO_AMBIENTE.PRD.descricao ||
            Ambiente.getDescricao() === TIPO_AMBIENTE.BET.descricao
        ) {
            siteId = 5012016;
        } else if (Ambiente.getDescricao() === TIPO_AMBIENTE.HML.descricao) {
            siteId = 5016347;
        }

        if (siteId) {
            const hotjarVersion = 6;

            Hotjar.init(siteId, hotjarVersion);

            console.info(`Hotjar inicializado com requisições partindo de ${window.location.hostname}.`);
            return true;
        }

        console.info(`Hotjar NÃO inicializado com requisições partindo de ${window.location.hostname}.`);
        return false;
    }

    /**
     * Identifica o usuário para o Hotjar.
     *
     * @param {object} user Objeto com as informações do usuário
     */
    static setUser(user) {
        if (!Ambiente.isHotjarInicializado()) {
            console.info('Hotjar.identify ignorado pois o Hotjar não foi inicializado.');
            return;
        }

        Hotjar.identify(user.id, {
            id: user.id ? user.id : Ambiente.INFORMACAO_DESCONHECIDA,
            localizacao: user.localizacao ? user.localizacao : Ambiente.INFORMACAO_DESCONHECIDA,
            username: user.username ? user.username : Ambiente.INFORMACAO_DESCONHECIDA,
            nome: user.nome ? user.nome : Ambiente.INFORMACAO_DESCONHECIDA
        });

        console.info(`HotjarUser [id:${user.id} | localizacao:${user.localizacao}].`);
    }
}

export default HotjarUtil;
